export default {
  seo: {
    home: {
      title: 'Artemida Studio — Kreative digitale løsninger',
      description:
        'Vi skaber skræddersyede websites uanset kompleksitet: landingssider, virksomhedssites og AI-assistenter.',
      keywords: 'webudvikling, landingsside, virksomhedssite, AI',
    },
    // 🔽 nyt: SEO til blogoversigten
    blog: {
      title: 'Blog — Artemida Studio',
      description:
        'Indsigter om webudvikling, design, AI-assistenter og opbygning af moderne virksomhedssites.',
      keywords: 'blog, webudvikling, design, ai, websites',
    },
  },

  header: {
    homeLink: 'Forside',
    aboutUsLink: 'Om os',
    servicesLink: 'Ydelser',
    ourProjectsLink: 'Vores projekter',
    contact: 'Kontakt',
    blogLink: 'Blog',
  },
  heroSection: {
    companyDescription:
      'Vi skaber skræddersyede hjemmesider uanset kompleksitet',
    contactUs: 'Kontakt os',
  },
  aboutUsSection: {
    aboutUsTitle: 'Om os',
    aboutUsDescription:
      'Hos Artemida Studio specialiserer vi os i at skabe skræddersyede landingssider og virksomhedssites, der hjælper virksomheder med at opbygge en stærk online tilstedeværelse. Vores mission er at levere moderne, funktionelle og visuelt imponerende løsninger, skræddersyet til din virksomheds behov.\n\n' +
      'Ved at kombinere kreativitet, den nyeste teknologi og en personlig tilgang bygger vi websites, der ikke blot er æstetisk tiltalende, men også hurtige, brugervenlige og fuldt responsive.\n\n' +
      'Uanset om du har brug for en konverteringsstærk landingsside eller et professionelt virksomhedssite, står Artemida Studio klar til at realisere din vision med skræddersyede løsninger i høj kvalitet.\n\n' +
      'Vælg professionalisme og kreativitet – lad os sammen bygge dit perfekte website!',
  },

  // Ydelser (hele sektionen styres af i18n)
  services: {
    ourServices: 'Vores ydelser',
    servicesDescription:
      'Vi specialiserer os i at skabe skræddersyede digitale løsninger af høj kvalitet, der løfter din forretning',
    contactUs: 'Kontakt os',
    items: [
      {
        key: 'landing',
        title: 'Landings-\n side',
        descriptionList: [
          'En veludført landingsside er et stærkt værktøj til at tiltrække kunder, øge konverteringer og styrke din brands online tilstedeværelse. Hos Artemida Studio skaber vi landingssider i høj kvalitet, skræddersyet til dine forretningsmål.',
          '✔️ Moderne og unikt design — Visuelt iøjnefaldende, brandtro sider, der fanger opmærksomhed.',
          '✔️ Høj konverteringsrate — Optimerede layouts og overbevisende CTA’er, der driver engagement.',
          '✔️ Hurtig og responsiv — Lynhurtig ydeevne og en sømløs oplevelse på alle enheder.',
          '✔️ Klar til SEO og marketing — Bygget efter best practice for at øge synlighed og organisk trafik.',
          '✔️ Fuldstændig tilpasning — Hvert detalje tilpasses dine behov og din brandidentitet.',
        ],
      },
      {
        key: 'corporate',
        title: 'Virksom - \n hedssite',
        descriptionList: [
          'Et professionelt virksomhedssite er afgørende for at opbygge troværdighed, fremvise dit brand og engagere kunder. Hos Artemida Studio udvikler vi skræddersyede virksomhedssites, der afspejler jeres værdier og får jer til at skille jer ud i den digitale verden.',
          '✔️ Professionelt og unikt design — Et stilrent, moderne udtryk tilpasset jeres brandidentitet.',
          '✔️ Fuldstændig tilpasning — Hvert element designes efter jeres forretningsbehov og mål.',
          '✔️ Hurtigt og sikkert — Optimeret til hastighed, sikkerhed og fejlfri performance.',
          '✔️ SEO- og marketingvenligt — Bygget efter best practice for at øge online synlighed og tiltrække leads.',
          '✔️ Mobil- og brugervenligt — Fuld responsivitet for en ensartet oplevelse på alle enheder.',
          '✔️ Let indholdsadministration — Nemme opdateringer via et brugervenligt CMS.',
        ],
      },
      {
        key: 'ai',
        title: 'Integration af AI-assistenter',
        descriptionList: [
          'Giv dit website et løft med AI! Hos Artemida Studio integrerer vi avancerede AI-assistenter, der forbedrer brugeroplevelsen, automatiserer opgaver og øger engagementet. Uanset om du har brug for en smart chatbot, automatiseret support eller AI-drevne anbefalinger, bygger vi løsninger skræddersyet til din forretning.',
          '✔️ Kundesupport 24/7 — AI-drevne chatbots håndterer forespørgsler døgnet rundt og øger tilfredsheden.',
          '✔️ Sømløs website-integration — Fungerer gnidningsfrit på dit site og udvider funktionaliteten uden forstyrrelser.',
          '✔️ Personaliseret brugeroplevelse — AI-drevne interaktioner tilpasset brugernes behov og præferencer.',
          '✔️ Leadgenerering og mersalg — Engagér besøgende, indsamle leads og guid kunder mod køb.',
          '✔️ Automatisering og effektivitet — Strømlin processer, reducer arbejdsmængde og svartider.',
          '✔️ Skræddersyede AI-løsninger — Fuldt tilpasset din forretningsmodel og specifikke krav.',
        ],
      },
    ],
  },
  contactSection: {
    title: 'Lad os tale om dit projekt',
    placeholderName: 'Navn',
    placeholderPhone: 'Telefon',
    placeholderEmail: 'E-mail',
    placeholderMessage: 'Fortæl os om dit projekt',
    sendButton: 'Send',
  },
};
